export const DOMAIN = "https://cabcity.fr";
export const PHONE_DISPLAY = "+33 1 84 60 68 87";
export const PHONE_TEL = "tel:+33184606887";

export const IMAGES = {
  hero: "/images/cabcity-hero.webp",
  van: "/images/cabcity-van.webp",
  paris: "/images/cabcity-paris.webp",
  aeroport: "/images/cabcity-aeroport.webp",
  aeroportAccueil: "/images/cabcity-aeroport-arrivee.webp",
  disneyland: "/images/cabcity-disneyland.webp",
  chauffeur: "/images/cabcity-chauffeur.webp",
  chauffeurPrive: "/images/cabcity-chauffeur-prive.webp",
  gareParis: "/images/cabcity-gare-paris.webp",
  versailles: "/images/cabcity-versailles.webp",
  interieur: "/images/cabcity-interieur.webp",
  groupe: "/images/cabcity-groupe.webp",
  famille: "/images/cabcity-famille.webp",
  van7passagers: "/images/cabcity-van-7-passagers.webp",
  break: "/images/cabcity-break.webp",
  berline: "/images/cabcity-berline.webp",
  og: "/images/og-image.webp",
};

export const NAV_LINKS = [
  { key: "home", label: "Accueil", to: "/", testid: "header-nav-link-home" },
  { key: "vehicles", label: "Nos véhicules", to: "/nos-vehicules/", testid: "header-nav-link-vehicules" },
  { key: "services", label: "Services", to: "/services/", testid: "header-nav-link-services" },
  { key: "destinations", label: "Destinations", to: "/destinations/", testid: "header-nav-link-destinations" },
  { key: "prices", label: "Tarifs", to: "/tarifs/", testid: "header-nav-link-tarifs" },
  { key: "about", label: "À propos", to: "/a-propos/", testid: "header-nav-link-apropos" },
  { key: "contact", label: "Contact", to: "/contact/", testid: "header-nav-link-contact" },
];

export const SERVICES = [
  {
    slug: "transfert-aeroport",
    title: "Transfert aéroport",
    desc: "Prise en charge à domicile, à l'hôtel ou au bureau vers les aéroports Paris-CDG et Paris-Orly, et accueil personnalisé à votre arrivée.",
    link: "/taxi-cdg/",
    image: IMAGES.aeroport,
    alt: "Chauffeur CAB CITY accueillant une famille avec bagages devant un Mercedes Classe V à l'aéroport de Paris",
  },
  {
    slug: "transfert-gare",
    title: "Transfert gare",
    desc: "Transferts depuis et vers toutes les gares parisiennes : Gare de Lyon, Montparnasse, Gare du Nord, Saint-Lazare et plus.",
    link: "/taxi-gare-paris/",
    image: IMAGES.gareParis,
    alt: "Mercedes Classe V CAB CITY circulant à Paris près de la Tour Eiffel pour un transfert gare",
  },
  {
    slug: "disneyland",
    title: "Disneyland Paris",
    desc: "Le trajet préféré des familles : transfert privé et confortable entre Paris, les aéroports et Disneyland Paris, avec tous vos bagages.",
    link: "/taxi-disneyland-paris/",
    image: IMAGES.disneyland,
    alt: "Famille avec enfants et valises accueillie par un chauffeur CAB CITY devant le château de Disneyland Paris",
  },
  {
    slug: "chauffeur-prive",
    title: "Chauffeur privé",
    desc: "Un chauffeur professionnel à votre service pour vos rendez-vous, événements, visites touristiques et déplacements privés à Paris.",
    link: "/chauffeur-prive-paris/",
    image: IMAGES.chauffeurPrive,
    alt: "Chauffeur privé CAB CITY accompagnant un client à Paris",
  },
  {
    slug: "transport-groupes",
    title: "Transport de groupes",
    desc: "Jusqu'à 8 passagers et leurs bagages dans un même véhicule spacieux : la solution idéale pour les groupes et les tribus.",
    link: "/taxi-van-paris/",
    image: IMAGES.groupe,
    alt: "Groupe de voyageurs avec valises montant à bord d'un taxi van CAB CITY",
  },
  {
    slug: "deplacements-pro",
    title: "Déplacements professionnels",
    desc: "Ponctualité, discrétion et confort pour vos trajets d'affaires, séminaires et navettes d'équipe en Île-de-France.",
    link: "/chauffeur-prive-paris/",
    image: IMAGES.berline,
    alt: "Berline business CAB CITY pour déplacements professionnels à Paris",
  },
];

export const DESTINATIONS = [
  { title: "Paris", desc: "Tous vos trajets dans la capitale, jour et nuit.", link: "/taxi-van-paris/", image: IMAGES.paris, alt: "Taxi van CAB CITY dans une rue parisienne avec la Tour Eiffel" },
  { title: "Aéroport Paris-CDG", desc: "Transferts vers et depuis Roissy Charles-de-Gaulle.", link: "/taxi-cdg/", image: IMAGES.aeroport, alt: "Transfert aéroport CDG en taxi van CAB CITY" },
  { title: "Aéroport Paris-Orly", desc: "Liaisons rapides et confortables vers Orly.", link: "/taxi-orly/", image: IMAGES.aeroportAccueil, alt: "Transfert aéroport Orly en taxi van CAB CITY" },
  { title: "Disneyland Paris", desc: "Le début des vacances dès la porte de chez vous.", link: "/taxi-disneyland-paris/", image: IMAGES.disneyland, alt: "Taxi van CAB CITY devant le château de Disneyland Paris" },
  { title: "Gares de Paris", desc: "Gare de Lyon, Montparnasse, Nord, Est, Saint-Lazare…", link: "/taxi-gare-paris/", image: IMAGES.groupe, alt: "Transfert vers les gares de Paris en taxi van CAB CITY" },
  { title: "Versailles", desc: "Excursions confortables vers le château et la ville.", link: "/taxi-versailles/", image: IMAGES.versailles, alt: "Taxi van avec chauffeur devant le château de Versailles" },
];

export const VEHICLES = [
  {
    name: "Mercedes Classe V",
    tag: "Van premium",
    passengers: "Jusqu'à 8 passagers",
    luggage: "Jusqu'à 10 bagages",
    desc: "Notre véhicule signature. Un intérieur spacieux et raffiné, des sièges cuir confortables et une grande capacité de bagages : la référence du taxi van à Paris.",
    image: IMAGES.van,
    alt: "Mercedes Classe V noir CAB CITY à Paris avec la Tour Eiffel en arrière-plan",
    featured: true,
  },
  {
    name: "Van 7 passagers",
    tag: "Van",
    passengers: "Jusqu'à 7 passagers",
    luggage: "Jusqu'à 8 bagages",
    desc: "Un van spacieux pour les familles et les groupes, avec un coffre généreux pour les valises, poussettes et sacs de voyage.",
    image: IMAGES.van7passagers,
    alt: "Van CAB CITY 7 places pour transfert aéroport avec bagages",
  },
  {
    name: "Break",
    tag: "Familiale",
    passengers: "Jusqu'à 4 passagers",
    luggage: "Jusqu'à 4 bagages",
    desc: "Un break confortable pour les petits groupes et les voyageurs avec plusieurs bagages.",
    image: IMAGES.break,
    alt: "Habitacle confortable d'un break CAB CITY",
  },
  {
    name: "Berline",
    tag: "Business",
    passengers: "Jusqu'à 3 passagers",
    luggage: "Jusqu'à 3 bagages",
    desc: "Une berline élégante et discrète pour vos déplacements professionnels et privés.",
    image: IMAGES.berline,
    alt: "Intérieur cuir d'une berline CAB CITY",
  },
];

export const GARES = [
  "Gare de Lyon",
  "Gare Montparnasse",
  "Gare du Nord",
  "Gare de l'Est",
  "Gare Saint-Lazare",
  "Gare d'Austerlitz",
  "Gare de Bercy",
];

export const FAQ_HOME = [
  {
    q: "Combien de personnes peut transporter un taxi van CAB CITY ?",
    a: "Nos vans Mercedes Classe V accueillent jusqu'à 8 passagers selon la configuration du véhicule, avec leurs bagages. C'est la solution idéale pour les familles, les groupes d'amis et les équipes professionnelles qui souhaitent voyager ensemble dans un même véhicule.",
  },
  {
    q: "Peut-on réserver un taxi 8 places à Paris ?",
    a: "Oui. CAB CITY propose des taxis van 7 et 8 places à Paris et en Île-de-France. Indiquez simplement le nombre de passagers et de bagages lors de votre demande de réservation afin que nous vous attribuions le véhicule adapté.",
  },
  {
    q: "Proposez-vous des transferts vers les aéroports CDG et Orly ?",
    a: "Oui, nous assurons les transferts entre Paris, l'Île-de-France et les aéroports Paris-Charles-de-Gaulle et Paris-Orly, au départ comme à l'arrivée. Votre chauffeur vous prend en charge à l'adresse de votre choix.",
  },
  {
    q: "Proposez-vous des transferts vers Disneyland Paris ?",
    a: "Oui, c'est l'une de nos destinations les plus demandées. Nous relions Paris, CDG et Orly à Disneyland Paris dans nos vans spacieux, parfaitement adaptés aux familles avec enfants et aux bagages nombreux.",
  },
  {
    q: "Peut-on réserver un taxi van pour une gare parisienne ?",
    a: "Bien sûr. Nous desservons toutes les gares de Paris : Gare de Lyon, Gare Montparnasse, Gare du Nord, Gare de l'Est, Gare Saint-Lazare, Gare d'Austerlitz et Gare de Bercy.",
  },
  {
    q: "Peut-on réserver à l'avance ?",
    a: "Oui, la réservation à l'avance est même recommandée : elle garantit la disponibilité d'un van adapté à votre groupe et permet à votre chauffeur d'organiser votre prise en charge dans les meilleures conditions.",
  },
];


export const SERVICES_EN = [
  {
    slug: "transfert-aeroport",
    title: "Airport transfers",
    desc: "Pick-up from your home, hotel or office to Paris-CDG and Paris-Orly airports, with personalized assistance on arrival.",
    link: "/taxi-cdg/",
    image: IMAGES.aeroport,
    alt: "CAB CITY driver welcoming a family with luggage beside a Mercedes V-Class at a Paris airport",
  },
  {
    slug: "transfert-gare",
    title: "Train station transfers",
    desc: "Transfers to and from all Paris train stations: Gare de Lyon, Montparnasse, Gare du Nord, Saint-Lazare and more.",
    link: "/taxi-gare-paris/",
    image: IMAGES.gareParis,
    alt: "CAB CITY Mercedes V-Class in Paris for a train station transfer",
  },
  {
    slug: "disneyland",
    title: "Disneyland Paris",
    desc: "A family favorite: private and comfortable transfers between Paris, the airports and Disneyland Paris, with all your luggage.",
    link: "/taxi-disneyland-paris/",
    image: IMAGES.disneyland,
    alt: "Family with children and luggage welcomed by a CAB CITY driver at Disneyland Paris",
  },
  {
    slug: "chauffeur-prive",
    title: "Private chauffeur",
    desc: "A professional chauffeur at your service for business meetings, events, sightseeing and private trips in Paris.",
    link: "/chauffeur-prive-paris/",
    image: IMAGES.chauffeurPrive,
    alt: "CAB CITY private chauffeur accompanying a client in Paris",
  },
  {
    slug: "transport-groupes",
    title: "Group transportation",
    desc: "Up to 8 passengers and their luggage in one spacious vehicle: the ideal solution for groups and families.",
    link: "/taxi-van-paris/",
    image: IMAGES.groupe,
    alt: "Group of travelers with luggage boarding a CAB CITY taxi van",
  },
  {
    slug: "deplacements-pro",
    title: "Business transportation",
    desc: "Punctuality, discretion and comfort for business trips, seminars and team transfers throughout Île-de-France.",
    link: "/chauffeur-prive-paris/",
    image: IMAGES.berline,
    alt: "CAB CITY business sedan for professional transportation in Paris",
  },
];

export const DESTINATIONS_EN = [
  { title: "Paris", desc: "All your journeys across the capital, day and night.", link: "/taxi-van-paris/", image: IMAGES.paris, alt: "CAB CITY taxi van on a Paris street with the Eiffel Tower" },
  { title: "Paris Charles-de-Gaulle Airport", desc: "Transfers to and from Charles-de-Gaulle Airport.", link: "/taxi-cdg/", image: IMAGES.aeroport, alt: "CAB CITY taxi van airport transfer to CDG" },
  { title: "Paris-Orly Airport", desc: "Fast and comfortable transfers to and from Orly.", link: "/taxi-orly/", image: IMAGES.aeroportAccueil, alt: "CAB CITY taxi van airport transfer to Orly" },
  { title: "Disneyland Paris", desc: "Your holiday starts the moment you leave your door.", link: "/taxi-disneyland-paris/", image: IMAGES.disneyland, alt: "CAB CITY taxi van in front of Disneyland Paris castle" },
  { title: "Paris train stations", desc: "Gare de Lyon, Montparnasse, Nord, Est, Saint-Lazare…", link: "/taxi-gare-paris/", image: IMAGES.groupe, alt: "CAB CITY taxi van transfer to Paris train stations" },
  { title: "Versailles", desc: "Comfortable trips to the Palace of Versailles and the city.", link: "/taxi-versailles/", image: IMAGES.versailles, alt: "Taxi van with driver in front of the Palace of Versailles" },
];

export const GARES_EN = [
  "Gare de Lyon",
  "Gare Montparnasse",
  "Gare du Nord",
  "Gare de l'Est",
  "Gare Saint-Lazare",
  "Gare d'Austerlitz",
  "Gare de Bercy",
];

export const FAQ_HOME_EN = [
  {
    q: "How many people can a CAB CITY taxi van carry?",
    a: "Our Mercedes V-Class vans can accommodate up to 8 passengers depending on the vehicle configuration, together with their luggage. They are ideal for families, groups of friends and professional teams who want to travel together in one vehicle.",
  },
  {
    q: "Can I book an 8-seater taxi in Paris?",
    a: "Yes. CAB CITY offers 7- and 8-seater taxi vans in Paris and Île-de-France. Simply indicate the number of passengers and luggage when booking so we can assign the right vehicle.",
  },
  {
    q: "Do you offer transfers to CDG and Orly airports?",
    a: "Yes. We provide transfers between Paris, Île-de-France and Paris Charles-de-Gaulle and Paris-Orly airports, both for departures and arrivals. Your driver will pick you up at the address of your choice.",
  },
  {
    q: "Do you offer transfers to Disneyland Paris?",
    a: "Yes, it is one of our most popular destinations. We connect Paris, CDG and Orly with Disneyland Paris in spacious vans, perfectly suited to families with children and plenty of luggage.",
  },
  {
    q: "Can I book a taxi van to a Paris train station?",
    a: "Of course. We serve all major Paris train stations: Gare de Lyon, Montparnasse, Gare du Nord, Gare de l'Est, Saint-Lazare, Austerlitz and Bercy.",
  },
  {
    q: "Can I book in advance?",
    a: "Yes. Booking in advance is recommended because it guarantees the availability of a suitable van for your group and allows your driver to organize your pick-up in the best possible conditions.",
  },
];

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": ["Organization", "LocalBusiness"],
  name: "CAB CITY",
  url: DOMAIN,
  telephone: "+33184606887",
  description:
    "CAB CITY — service de taxi van et chauffeur privé à Paris et Île-de-France. Mercedes Classe V jusqu'à 8 passagers, transferts aéroports CDG et Orly, Disneyland Paris et gares.",
  areaServed: ["Paris", "Île-de-France", "Aéroport Paris-Charles-de-Gaulle", "Aéroport Paris-Orly", "Disneyland Paris", "Versailles"],
};
